import { load as parseYaml } from 'js-yaml';

export interface ParsedMarkdown {
  data: Record<string, unknown>;
  content: string;
}

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/;

/**
 * 解析 Markdown 文件开头的 YAML frontmatter。
 * 不用 gray-matter：它在浏览器 bundle 中依赖 Node 的 Buffer，会直接崩溃。
 */
export function parseFrontmatter(raw: string): ParsedMarkdown {
  const match = FRONTMATTER_RE.exec(raw);
  if (!match) {
    return { data: {}, content: raw };
  }

  const parsed = parseYaml(match[1] ?? '');
  const data =
    parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : {};

  return { data, content: raw.slice(match[0].length) };
}
